"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgentDTO = void 0;
class AgentDTO {
}
exports.AgentDTO = AgentDTO;
//# sourceMappingURL=agent-dto.js.map